import React from 'react';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import './FloatingButtons.css';

const FloatingButtons = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá, gostaria de receber atendimento.');
    window.open(`https://wa.me/5511989887113?text=${message}`, '_blank');
  };

  const handleInstagramClick = () => {
    window.open('https://instagram.com/convertrex_', '_blank');
  };

  return (
    <div className="floating-buttons">
      <button 
        className="floating-button whatsapp"
        onClick={handleWhatsAppClick}
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </button>
      <button 
        className="floating-button instagram"
        onClick={handleInstagramClick}
        aria-label="Instagram"
      >
        <FaInstagram />
      </button>
    </div>
  );
};

export default FloatingButtons; 